import styled from 'styled-components';

export const PricingModelStyled = styled.div`
  .pricingModel {
    &__box {
      background: var(--color-sonata-secondary-White, #FFF);
      border-radius: var(--spacing-8);
      padding: var(--spacing-24);

      &Title {
        font: var(--font-title-400-regular);
        color: var(--color-sonata-primary-800, #162237);
        margin-bottom: var(--spacing-16);
      }
    }
    
    &__configContainer {
      display: flex;
      flex-direction: column;
    }
      
    .switchLabel{
      border-color: ${props => props.theme.uiColors.componentControllersDefault};
      &:after {
        border-color: ${props => props.theme.uiColors.componentControllersDefault};
      }
    }

    &__errorToast {
      margin-bottom: var(--spacing-16);
    }  
  }
`;
